import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

/** Redirects unauthenticated visitors to the admin login page. */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
